import request from '../http/request'
export const getTokenByCode = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/login`, params)
}

export const getMac = params => {
  return request.get(`${process.env.REACT_APP_API_MAC_URL}/pc/mac`, {
    params,
    mac: true
  })
}

export const getMacForPhone = params => {
  return request.get(`${process.env.REACT_APP_API_MAC_URL_PHONE}/phoneMac`, {
    params,
    mac: true
  })
}

export const deviceLogin = macAddress => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/nfc/rf/device/login?macAddress=${macAddress}`,
    {},
    {
      nfc: true,
      RFHeader: { isRf: true }
    }
  )
}
